<template>
    <div class="input-cont">
        <InputComponent
            v-for="(input, iKey) in filteredInputs"
            :key="iKey"
            :input="input"
            ref="inputComponents"
        />
    </div>
</template>

<script>
import InputComponent from '@/components/inputs/InputComponent.vue'

export default {
  name: 'InputContainer',
  components: {
    InputComponent
  },
  props: ['inputs'],
  data () {
    return {
      filteredInputs: []
    }
  },
  created () {
    this.filterSelectInputs()
  },
  methods: {
    handleInputUpdated: function (value) {
      this.$emit('inputUpdated', value)
    },
    getValues: function () {
      const inputComponents = this.$refs.inputComponents
      const values = inputComponents.map(component => ({
        display: component.input.display,
        id: component.id,
        value: component.getValue(),
        required: component.input.required,
        format: component.input.format
      }))
      return values
    },
    filterSelectInputs: function () {
      this.filteredInputs = this.inputs.filter((e) => {
        return e.type !== 'select'
      })
    }
  }
}
</script>

<style lang="less" scoped>
.input-cont {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    align-items: center;
}
</style>
